import * as React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { formatLocalNumber } from '../../../util/Math';
import AddIcon from '@material-ui/icons/Add';
import InvoiceStateTag from '../../invoice/InvoiceStateTag';
import { DailyReportInvoiceOpenContext } from '../../../screens/dailyReport/DailyReportScreen';
import { useContext } from 'react';
import { TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { InvoiceService } from '../../../models/invoice/invoice.service';
import { ReceiptService } from '../../../models/invoice/receipt.service';
import { Invoice } from '../../../models/InvoiceModel';
import { DailyReportContext } from '../../../screens/dailyReport/DailyReportDetailScreen';

interface Props {
  invoices?: Invoice[];
  onRemove?: (invoice: Invoice) => void;
  onAdd?: (invoice: Invoice) => void;
  onReceive?: (invoice: Invoice) => void;
  onReject?: (invoice: Invoice) => void;
}

const useStyles = makeStyles(theme => ({
  table: {},
  header: {
    backgroundColor: '#f8fcff',
  },
  body: {},
  content: {
    marginTop: theme.spacing(1),
  },
}));

/**
 * 日報の請求一覧テーブル
 * @param props
 * @returns
 */
const DailyReportInvoiceList = (props: Props) => {
  const classes = useStyles();

  const { isExpandedInvoice } = useContext(DailyReportInvoiceOpenContext);

  const { invoices, onAdd, onRemove, onReceive, onReject } = props;

  const [expanded, setExpanded] = React.useState<boolean>(isExpandedInvoice);

  const handleRemove = (invoice: Invoice) => {
    if (onRemove) {
      onRemove(invoice);
    }
  };
  const handleAdd = (invoice: Invoice) => {
    if (onAdd) {
      onAdd(invoice);
    }
  };
  if (invoices == undefined) {
    return <></>;
  }

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const renderExpandButton = () => {
    return (
      <TouchableOpacity
        style={{
          backgroundColor: '#6c97ee',
          borderRadius: 100,
          width: 20,
          height: 20,
          marginRight: 3,
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
        onPress={handleExpand}
      >
        <MaterialCommunityIcons name={expanded ? 'minus' : 'plus'} size={20} color="black" />
      </TouchableOpacity>
    );
  };

  // const onReceive = async (invoice: Invoice) => {
  //   const receiptService = new ReceiptService();
  //   const res = await receiptService.receipt({ id: invoice.id });
  //   console.log(res);

  // };

  // const onReject = (invoice: Invoice) => {
  //   console.log('reject', invoice);
  // };

  React.useEffect(() => {
    setExpanded(isExpandedInvoice);
  }, [isExpandedInvoice]);

  return (
    <>
      {/* <Button onClick={onTestReload}>{"reload"}</Button> */}
      <TableContainer component={Paper} style={{ marginTop: 5 }}>
        <Table className={classes.table}>
          <TableHead className={classes.header}>
            <TableRow>
              <TableCell style={{ minWidth: 100 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                  }}
                >
                  {renderExpandButton()}状態{' '}
                </div>
              </TableCell>
              {!expanded && <TableCell style={{ minWidth: 100 }}>請求日</TableCell>}
              {!expanded && <TableCell style={{ minWidth: 100 }}>請求元</TableCell>}
              {!expanded && <TableCell style={{ minWidth: 100 }}>請求先</TableCell>}
              {!expanded && <TableCell style={{ minWidth: 100 }}>中分類</TableCell>}
              <TableCell style={{ minWidth: 100 }}>小分類</TableCell>
              <TableCell style={{ minWidth: 100 }}>仕事</TableCell>
              <TableCell style={{ minWidth: 100 }}>金額</TableCell>
              {onAdd && <TableCell style={{ minWidth: 100 }}>追加</TableCell>}
              {onRemove && <TableCell style={{ minWidth: 100 }}>削除</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {invoices.length ? (
              invoices.map(invoice => (
                <TableRow key={invoice.id}>
                  <TableCell>
                    <InvoiceStateTag invoice={invoice} onReceive={onReceive} onReject={onReject} />
                  </TableCell>
                  {!expanded && <TableCell>{invoice.billing_date}</TableCell>}
                  {!expanded && <TableCell>{invoice.from_org_obj?.name}</TableCell>}
                  {!expanded && <TableCell>{invoice.to_org_obj?.name}</TableCell>}
                  {!expanded && <TableCell>{invoice.work_type?.name}</TableCell>}
                  <TableCell>{invoice.work_type_small?.name}</TableCell>
                  <TableCell>{invoice.work}</TableCell>
                  <TableCell>{formatLocalNumber(invoice.total)}</TableCell>
                  {onAdd && (
                    <TableCell>
                      <IconButton
                        onClick={() => handleAdd(invoice)}
                        aria-label="add"
                        color="primary"
                        size="small"
                      >
                        <AddIcon />
                      </IconButton>
                    </TableCell>
                  )}
                  {onRemove && (
                    <TableCell>
                      <IconButton
                        onClick={() => handleRemove(invoice)}
                        aria-label="remove"
                        color="secondary"
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} style={{ textAlign: 'center', padding: '16px' }}>
                  請求データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DailyReportInvoiceList;
